import axios from "axios";
import { API_BASE_URL } from "../config/env";

// One base URL for every request: config/env.js (REACT_APP_API_BASE_URL, or
// https://vrplay.in/api). It used to have a different fallback here than in
// env.js, which is how two parts of the app could end up on different hosts.
const apiClient = axios.create({
  baseURL: API_BASE_URL,
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    // A verify_token.php block for "you must change your password before
    // doing anything else" — NOT the same as an invalid/expired session,
    // so this must NOT clear the token or send them to /login. It's a
    // valid session that's deliberately restricted to one destination.
    if (error.response?.status === 403 && error.response?.data?.mustChangePassword) {
      if (window.location.pathname !== "/change-password") {
        window.location.href = "/change-password";
      }
      return Promise.reject(error);
    }

    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("rootToken");
      if (window.location.pathname !== "/login" && window.location.pathname !== "/") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export default apiClient;
